import { EChartsOption } from "echarts";
import { Box, Container } from "@mui/material";
import { RopChart } from "../../../../main/components/RopChart";
import { isNumberNullOrNegative, numberPtBrPercent01 } from "../../../../main/utils/utils";
import { EmptyTable } from "../../../clients/components/EmptyState";
import { AcompanhamentoMensal } from "../../types";

export default function PerformanceMonthlyChart(props: {
    acompanhamentoMensal: AcompanhamentoMensal
}) {
    const { acompanhamentoMensal } = props
    const hasData = Object.keys(acompanhamentoMensal).length > 0

    const dias = Object.keys(acompanhamentoMensal)
        .map(Number)
        .sort((a, b) => a - b);

    const disponibilidadeData = dias.map(dia => {
        var acompanhamentoDia = acompanhamentoMensal[dia];
        return acompanhamentoDia ? acompanhamentoDia.disponibilidade : null
    }
    );
    const performanceRatioData = dias.map(dia => {
        var acompanhamentoDia = acompanhamentoMensal[dia];
        return acompanhamentoDia ? acompanhamentoDia.performanceRatio : null
    }
    );
    const energiaGeradaData = dias.map(dia => {
        var acompanhamentoDia = acompanhamentoMensal[dia];
        return acompanhamentoDia ? acompanhamentoDia.energiaGerada : null
    }
    );

    const xAxisLabels = dias.map(dia => `${dia}`);

    const options: EChartsOption = {
        title: {
            text: "Desempenho Diário da Usina",
            textStyle: {
                fontSize: 12,
            },
        },
        legend: {
            itemWidth: 8,
            itemHeight: 8,
            textStyle: {
                fontSize: 13,
            },
        },
        grid: {
            left: 10,
            right: 40,
            bottom: 0,
            // top: 10,
            containLabel: true,
        },
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "shadow",
            },
            formatter: function (params: any) {
                let tooltip = `${params[0].axisValue}<br/>`;

                params.forEach((item: any) => {
                    let value = item.data;
                    if (value === '-' || value == null) {
                        tooltip += `${item.marker} ${item.seriesName}: -<br/>`;
                        return;
                    }

                    if (item.seriesName === 'Energia (MWh)') {
                        tooltip += `${item.marker} ${item.seriesName}: ${value.toFixed(2)} MWh<br/>`;
                    } else {
                        tooltip += `${item.marker} ${item.seriesName}: ${numberPtBrPercent01(value)}<br/>`;
                    }
                });

                return tooltip;
            }
        },
        backgroundColor: "transparent",
        xAxis: {
            type: 'category',
            data: xAxisLabels,
            axisLabel: {
                rotate: 0,
                fontSize: 10,
                interval: 0
            }
        },
        yAxis: [
            {
                type: 'value',
                name: 'Energia (MWh)',
                axisLabel: {
                    fontSize: 10,
                    formatter: function (value: number) {
                        return isNumberNullOrNegative(value) ? "-" : value.toFixed(2) + " MWh";
                    }
                },
                splitLine: {
                    show: false
                }
            },
            {
                type: 'value',
                name: 'PR e Disponibilidade (%)',
                min: 0,
                max: 1,
                axisLabel: {
                    fontSize: 10,
                    formatter: function (value: number) {
                        return isNumberNullOrNegative(value) ? "-" : `${numberPtBrPercent01(value)}`;
                    }
                },
                splitLine: {
                    show: false
                }
            }
        ],
        series: [
            {
                name: 'Energia (MWh)',
                type: 'bar',
                data: energiaGeradaData.map(val => val ?? '-'),
                itemStyle: {
                    color: '#EE7D00'
                }
            },
            {
                name: 'Disponibilidade (%)',
                type: 'line',
                data: disponibilidadeData.map(val => val ?? '-'),
                yAxisIndex: 1,
                itemStyle: {
                    color: '#6D0DB8'
                }
            },
            {
                name: 'Performance Ratio (%)',
                type: 'line',
                data: performanceRatioData.map(val => val ?? '-'),
                yAxisIndex: 1,
                itemStyle: {
                    color: '#fac858'
                }
            }
        ]
    }

    return (
        <>
            {hasData ? (
                <Container
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        height: "90%",
                        width: "100%",
                    }}
                >
                    <RopChart option={options} />
                </Container>
            ) : (
                <Box
                    sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <EmptyTable title="Nenhum dado encontrado!" />
                </Box>
            )}
        </>
    );
}
